<template>
  <PreviewFrame :accent="slide.accent">
    <template #presenter>
      <div class="yt-player">
        <span class="yt-play" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="22" height="22">
            <polygon points="9,6 9,18 19,12" fill="white" />
          </svg>
        </span>
        <div class="yt-controls">
          <span class="yt-track">
            <span class="yt-fill"></span>
            <span class="yt-thumb"></span>
          </span>
          <span class="yt-time"></span>
        </div>
      </div>
    </template>
  </PreviewFrame>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'
import type { SlideType } from '../../data/slideTypeCatalog'
import PreviewFrame from './PreviewFrame.vue'

export default Vue.extend({
  name: 'PreviewYoutube',
  components: { PreviewFrame },
  props: { slide: { type: Object as PropType<SlideType>, required: true } },
})
</script>

<style scoped lang="scss">
.yt-player {
  position: relative;
  flex: 1;
  border-radius: 8px;
  background: #1A1A2E;
  min-height: 150px;
  display: grid;
  place-items: center;
  overflow: hidden;
}
.yt-play {
  width: 46px;
  height: 46px;
  border-radius: 999px;
  background: #FF0000;
  display: grid;
  place-items: center;
  box-shadow: 0 4px 14px -4px rgba(255, 0, 0, 0.55);
}
.yt-controls {
  position: absolute;
  left: 12px;
  right: 12px;
  bottom: 10px;
  display: grid;
  grid-template-columns: 1fr 32px;
  align-items: center;
  gap: 10px;
}
.yt-track {
  position: relative;
  display: block;
  height: 4px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.25);
}
.yt-fill {
  position: absolute;
  inset: 0 auto 0 0;
  width: 38%;
  background: #FF0000;
  border-radius: 999px;
  animation: yt-progress 4s linear infinite;
}
.yt-thumb {
  position: absolute;
  top: 50%;
  left: 38%;
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: #FF0000;
  transform: translate(-50%, -50%);
  animation: yt-thumb 4s linear infinite;
}
.yt-time {
  height: 6px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.4);
}

@keyframes yt-progress {
  0% { width: 38%; }
  100% { width: 78%; }
}
@keyframes yt-thumb {
  0% { left: 38%; }
  100% { left: 78%; }
}

@media (prefers-reduced-motion: reduce) {
  .yt-fill, .yt-thumb { animation: none; }
}
</style>
